import { useRegisterSW } from 'virtual:pwa-register/react'
import { RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

// Verifica nova versão a cada hora, para quem deixa o app instalado aberto por muito tempo
const UPDATE_CHECK_INTERVAL_MS = 60 * 60 * 1000

export function PwaUpdatePrompt() {
	const { t } = useTranslation()
	const {
		needRefresh: [needRefresh, setNeedRefresh],
		updateServiceWorker,
	} = useRegisterSW({
		onRegisteredSW(_swUrl, registration) {
			if (!registration) return
			setInterval(() => {
				if (navigator.onLine) registration.update()
			}, UPDATE_CHECK_INTERVAL_MS)
		},
	})

	if (!needRefresh) return null

	return (
		<div
			className="fixed inset-x-4 bottom-[calc(1rem+env(safe-area-inset-bottom))] z-50 mx-auto flex max-w-md items-center gap-3 rounded-lg bg-kaefer-dark-grey p-4 text-white shadow-lg"
			role="status"
		>
			<RefreshCw className="size-5 shrink-0" />
			<div className="min-w-0 flex-1">
				<p className="font-semibold text-sm">{t('pwa.updateAvailable')}</p>
				<p className="text-white/80 text-xs">{t('pwa.updateDescription')}</p>
			</div>
			<div className="flex shrink-0 gap-2">
				<Button
					className="text-white hover:bg-white/10 hover:text-white"
					onClick={() => setNeedRefresh(false)}
					size="sm"
					variant="ghost"
				>
					{t('pwa.later')}
				</Button>
				<Button
					onClick={() => updateServiceWorker(true)}
					size="sm"
					variant="secondary"
				>
					{t('pwa.update')}
				</Button>
			</div>
		</div>
	)
}
